import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import { Grid, IconButton } from "@mui/material";
import dummyImg from "../../assets/images/dummy.jpg";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import moment from "moment";
import { BASE_URL } from "../../constant/apiURL";

const NewsAdsDialog = ({ newsData, open, setOpen }) => {
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  const createdAt = moment(newsData?.createdAt).format("D MMMM");

  return (
    <div>
      <Dialog
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: "#06623b",
            borderRadius: 0,
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          aria-label="delete"
          sx={{
            position: "absolute",
            color: "white",
            right: "2%",
            top: "3%",
          }}
        >
          <CloseRoundedIcon />
        </IconButton>
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ textAlign: "center", color: "white" }}
        >
          News
        </DialogTitle>
        <DialogContent sx={{ my: "25px" }}>
          <Grid container>
            <Grid item xs={12} md={7} paddingRight="10px">
              <DialogContentText
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
                fontSize={{ xs: "12px", md: "15px" }}
              >
                {newsData?.title}
              </DialogContentText>
              <DialogContentText
                sx={{ color: "white", fontSize: "13px", marginBottom: "10px" }}
                fontSize={{ xs: "10px", md: "13px" }}
              >
                {newsData?.body}
              </DialogContentText>
              <DialogContentText
                sx={{ color: "white", fontWeight: "bold" }}
                fontSize={{ xs: "10px", md: "13px" }}
              >
                {createdAt}
              </DialogContentText>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                src={
                  newsData?.picture
                    ? `${BASE_URL}${newsData?.picture}`
                    : dummyImg
                }
                width="100%"
                height="200px"
                style={{ objectFit: "contain" }}
                alt="player-img"
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default NewsAdsDialog;
